import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import DualListBox from 'ui/duallist/DualListBox';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    row: {
        width: '100%',
    },
    groups: {
        marginTop: 10,
        height: 300,
    },
});

const CreateUserStep = props => {
    const {
        classes,
        userDetails,
        userDetailsErrors,
        companyGroups,
        onChange,
    } = props;
    const readOnly = false;

    return (
        <div className={classes.container}>
            <Typography variant="h6">Company groups</Typography>
            <div className={classes.row}>
                <Typography variant="subtitle1">
                    Assign at least one company group for every user. The user
                    will have access to all of the companies in the company
                    group base on the roles chosen on the previous screen.
                </Typography>
                <DualListBox
                    className={classes.groups}
                    disabled={readOnly}
                    options={companyGroups.map(r => ({
                        value: r.uuid,
                        label: r.name,
                    }))}
                    initialValue={userDetails.company_groups}
                    sourceListHeaderName="Available company groups"
                    destinationListHeaderName="Assigned company groups"
                    destinationListError={Boolean(
                        userDetailsErrors.company_groups
                    )}
                    onChange={values => onChange('company_groups', values)}
                />
            </div>
        </div>
    );
};

export default withStyles(styles)(CreateUserStep);
